import cloneDeep from 'lodash/cloneDeep';
import generalTransformer from '@/services/general/filters/serverTableDataTransformer';
import formatDate from '@/services/general/formatIsoDate';
import { DATES_PREAVIS, DATES_RENOUVELLEMENT } from '@/configuration/commande/commandeConf';

export default function transformer(serverTableData) {
  if (!serverTableData.orderBy) {
    serverTableData.ascending = 1;
    serverTableData.orderBy = 'creationTime';
  }
  if (serverTableData.orderBy === 'commercial') {
    serverTableData.orderBy = 'commercialId';
  }
  const data = cloneDeep(serverTableData);
  if (!data.query) return generalTransformer(data);
  delete data.query.dates;
  if (data.query.optionDate === DATES_PREAVIS) {
    data.query.datesPreavis = {
      dateDebut: serverTableData.query.dates.dateDebut
        ? formatDate(serverTableData.query.dates.dateDebut) : null,
      dateFin: serverTableData.query.dates.dateFin
        ? formatDate(serverTableData.query.dates.dateFin) : null,

    };
  }
  if (data.query.optionDate === DATES_RENOUVELLEMENT) {
    data.query.datesRenouvellement = {
      dateDebut: serverTableData.query.dates.dateDebut
        ? formatDate(serverTableData.query.dates.dateDebut) : null,
      dateFin: serverTableData.query.dates.dateFin
        ? formatDate(serverTableData.query.dates.dateFin) : null,

    };
  }
  if (data.query.dateCampagne) {
    data.query.dateCampagne = {
      dateDebut: serverTableData.query.dateCampagne.dateDebut
        ? formatDate(serverTableData.query.dateCampagne.dateDebut) : null,
      dateFin: serverTableData.query.dateCampagne.dateFin
        ? formatDate(serverTableData.query.dateCampagne.dateFin) : null,
    };
  }
  return generalTransformer(data);
}
